$(function () {

    var $body = $('body');
    // move the mobile nav to the end of the body to avoid IE bug
    $body.append($('.mobile-nav'));

    var $mobileMenuToggle = $('.mobile-nav-toggle');

    var mobileMenuToggleClass = 'mobile-nav--opened';
    var sideMenuClass = 'side-menu--opened';
    var sideMenuVisibility = 'side-menu-visible';

    $mobileMenuToggle.on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        $body.toggleClass(mobileMenuToggleClass);
        $('.mobile-nav').toggleClass(sideMenuVisibility);
    });

    $body.on('click', function (e) {
        if (!$(e.target).parents('.mobile-nav').length && !$(e.target).hasClass('mobile-nav')) {
            $body.removeClass(mobileMenuToggleClass);
            $('.mobile-nav').removeClass(sideMenuClass).removeClass(sideMenuVisibility);
        }
    });
});